import React from 'react';

import { useTheme } from 'styled-components';

import { copyToClipBoard } from '~/helpers/clipboad';

import { FaRegUser, FaCopy } from 'react-icons/fa';
import { MdEmail } from 'react-icons/md';
import { FaPhone } from 'react-icons/fa';
import { FaInfoCircle } from 'react-icons/fa';
import { FaLocationArrow } from 'react-icons/fa';

import { Area, Grid, GridLine, GridHeadItem, GridItem } from '~/components';

import { Align, Client, Content, Summary, Thumb } from './styles';

import { ParamsProps } from './interface';
import { toNumber } from '~/helpers/number';

const DetalhesDoPedido: React.FC<ParamsProps> = ({ pedido }) => {
  const { colors } = useTheme();

  return (
    <tr>
      <td colSpan={9}>
        <Content>
          <Client>
            <div>
              <i>
                <FaRegUser size={18} color={colors.IC1} />
              </i>
              <div>
                <span>Nome:</span>
                {pedido.cliente.tipo === 'PF' ? (
                  <strong>
                    {pedido.cliente.nome} {pedido.cliente.sobrenome}
                  </strong>
                ) : (
                  <strong>{pedido.cliente.razaosocial}</strong>
                )}
              </div>
              <button onClick={() => copyToClipBoard(pedido.cliente.nome)}>
                <FaCopy size={20} color={colors.IC1} />
              </button>
            </div>
            <div>
              <i>
                <MdEmail size={18} color={colors.IC1} />
              </i>
              <div>
                <span>E-mail:</span>
                <strong>{pedido.cliente.email}</strong>
              </div>
              <button onClick={() => copyToClipBoard(pedido.cliente.email)}>
                <FaCopy size={20} color={colors.IC1} />
              </button>
            </div>
            <div>
              <i>
                <FaPhone size={18} color={colors.IC1} />
              </i>
              <div>
                <span>Telefone:</span>
                <strong>{pedido.cliente.telefone}</strong>
              </div>
              <button onClick={() => copyToClipBoard(pedido.cliente.telefone)}>
                <FaCopy size={20} color={colors.IC1} />
              </button>
            </div>
            <div>
              <i>
                <FaInfoCircle size={18} color={colors.IC1} />
              </i>
              <div>
                <span>Documento:</span>
                {pedido.cliente.tipo === 'PF' ? (
                  <strong>{pedido.cliente.cpf}</strong>
                ) : (
                  <strong>{pedido.cliente.cnpj}</strong>
                )}
              </div>
              <button onClick={() => copyToClipBoard(pedido.cliente.cpf)}>
                <FaCopy size={20} color={colors.IC1} />
              </button>
            </div>

            {pedido.endereco.logradouro !== '' ? (
              <div>
                <i>
                  <FaLocationArrow size={18} color={colors.IC1} />
                </i>
                <div>
                  <span>Endereço:</span>
                  <strong>{`${pedido.endereco.logradouro}, ${pedido.endereco.numero}`}</strong>
                  <span>Bairro:</span>
                  <strong>{pedido.endereco.bairro}</strong>

                  {pedido.endereco.complemento &&
                  pedido.endereco.complemento !== '' ? (
                    <>
                      <span>Complemento:</span>
                      <strong>
                        Complemento: {pedido.endereco.complemento}
                      </strong>
                    </>
                  ) : null}
                  <span>Cidade/UF</span>
                  <strong>
                    {pedido.endereco.cidade}, {pedido.endereco.uf}
                  </strong>
                  <span>CEP:</span>
                  <strong>{pedido.endereco.cep}</strong>
                </div>
                <button
                  onClick={() =>
                    copyToClipBoard(
                      `${pedido.endereco.logradouro}, ${pedido.endereco.numero} - ${pedido.endereco.bairro} - ${pedido.endereco.cidade}/${pedido.endereco.uf} (${pedido.endereco.cep})`,
                    )
                  }
                >
                  <FaCopy size={20} color={colors.IC1} />
                </button>
              </div>
            ) : null}
          </Client>

          <Area>
            <Grid>
              <GridLine>
                <GridHeadItem title="" width={80} />
                <GridHeadItem title={'SKU'} />
                <GridHeadItem title={'Descrição'} />
                <GridHeadItem title={'Quantidade'} />
                <GridHeadItem title={'Preço Unitário'} />
                <GridHeadItem title={'Total'} />
              </GridLine>
              {pedido.itens.map(item => (
                <GridLine key={item.sku}>
                  <GridItem width={80}>
                    <Thumb>
                      <img
                        src={item.fotoprincipal}
                        title={item.sku}
                        alt={item.sku}
                        style={{ borderRadius: 8 }}
                      />
                    </Thumb>
                  </GridItem>
                  <GridItem>
                    <Align>{item.sku}</Align>
                  </GridItem>
                  <GridItem>
                    <Align>
                      <strong>{item.descricao}</strong>
                    </Align>
                  </GridItem>
                  <GridItem>
                    <Align>{item.qtd}</Align>
                  </GridItem>
                  <GridItem>
                    <Align>{item.precounitformatado}</Align>
                  </GridItem>
                  <GridItem>
                    <Align>
                      {(
                        toNumber(item.precounit) * toNumber(item.qtd)
                      ).toLocaleString('pt-br', {
                        style: 'currency',
                        currency: 'BRL',
                      })}
                    </Align>
                  </GridItem>
                </GridLine>
              ))}
            </Grid>
          </Area>

          <Summary>
            <div>
              <span></span>
              <i></i>
              <strong></strong>
            </div>
            <div>
              <span>Produtos:</span>
              <i></i>
              <strong>{pedido.precoprodutosformatado}</strong>
            </div>
            <div>
              <span>Desconto:</span>
              <i></i>
              <strong>{pedido.precodescontoformatado}</strong>
            </div>
            <div>
              <span>Taxas:</span>
              <i></i>
              <strong>{pedido.precotaxas}</strong>
            </div>
            <div>
              <span>Frete:</span>
              <i></i>
              <strong>{pedido.precofreteformatado}</strong>
            </div>
            <div>
              <span></span>
              <i></i>
              <strong></strong>
            </div>
            <ins></ins>
            <div className="total">
              <span>Total:</span>
              <i></i>
              <strong>{pedido.precototalformatado}</strong>
            </div>
          </Summary>
        </Content>
      </td>
    </tr>
  );
};

export default DetalhesDoPedido;
